import React from "react";
import { Grid, makeStyles, Typography, Divider } from "@material-ui/core";
import { birthDateRangeCheck, displayAddress, displayDateMMDDYYYY, displayName } from "../helper/DisplayUtil";
import { Block, CheckCircle } from "@material-ui/icons";
import {
  BirthSexOptions,
  FeeStatus,
  IdentificationStatus,
  RegistrationStatus,
  RegistrationType,
} from "../../Base/AdoptionConstants";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
  },
  section: {
    padding: "3px 0 15px 45px",
  },
}));

export default function RegistrationFields({ registration }) {
  const classes = useStyles();

  return (
    <>
      <Grid container justify="center" alignItems="flex-start">
        {registration?.paperRegistration && (
          <Grid className={classes.section} container>
            <Typography variant="body2">
              <strong>Paper form filed by </strong>{" "}
              {displayName(
                registration.createdBy.contactInformation.firstName,
                registration.createdBy.contactInformation.middleName,
                registration.createdBy.contactInformation.lastName
              )}
            </Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <Typography variant="body2">
            <strong>Registrant Information</strong>
          </Typography>
          <Divider />
          <Grid className={classes.section} container>
            <Grid item md={6} xs={12}>
              <Grid container>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Name </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">
                    {displayName(
                      registration.registrant.contactInformation.firstName,
                      registration.registrant.contactInformation.middleName,
                      registration.registrant.contactInformation.lastName
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Phone </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">
                    <span> {registration.registrant.contactInformation.phone}</span>
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Email </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">
                    <span> {registration.registrant.contactInformation.email}</span>
                  </Typography>
                </Grid>
                <Grid item md={2} xs={4}>
                  <Typography variant="body2">
                    <strong>Address </strong>
                  </Typography>
                </Grid>
                <Grid item md={6} xs={8}>
                  <Typography variant="body2">
                    {displayAddress(
                      registration.registrant.contactInformation.streetAddress1,
                      registration.registrant.contactInformation.streetAddress2,
                      registration.registrant.contactInformation.city,
                      registration.registrant.contactInformation.state,
                      registration.registrant.contactInformation.zipCode,
                      "",
                      registration.registrant.contactInformation.country
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={6} xs={12}>
              <Grid container>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Type </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">{RegistrationType[registration.registrationType].label}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Registration Date </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">{displayDateMMDDYYYY(registration.createdDate)}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Updated Date </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">{displayDateMMDDYYYY(registration.updatedDate)}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Update By </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">
                    {displayName(
                      registration.updatedBy.contactInformation.firstName,
                      registration.updatedBy.contactInformation.middleName,
                      registration.updatedBy.contactInformation.lastName
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2">
            <strong>Contact Information</strong>
          </Typography>
          <Divider />
          {registration.contactInformation == null ? (
            <Grid className={classes.section} container>
              <Typography variant="body2">Registrant chose not to share contact information with a match</Typography>{" "}
            </Grid>
          ) : (
            <Grid className={classes.section} container>
              <Grid item md={6} xs={12}>
                <Typography variant="body2">
                  <strong>Name </strong>
                  <span>
                    {displayName(
                      registration.contactInformation?.firstName,
                      registration.contactInformation?.middleName,
                      registration.contactInformation?.lastName
                    )}
                  </span>
                </Typography>
                <Typography variant="body2">
                  <strong>Email </strong>
                  <span>{registration.contactInformation?.email}</span>
                </Typography>
                <Typography variant="body2">
                  <strong>Phone </strong>
                  <span>{registration.contactInformation?.phone}</span>
                </Typography>
                <Typography variant="body2">
                  <strong>Address </strong>
                  <span>
                    {registration.contactInformation != null &&
                      displayAddress(
                        registration.contactInformation?.streetAddress1,
                        registration.contactInformation?.streetAddress2,
                        registration.contactInformation?.city,
                        registration.contactInformation?.state,
                        registration.contactInformation?.zipCode,
                        "",
                        registration.contactInformation?.country
                      )}
                  </span>
                </Typography>
              </Grid>
              <Grid item md={6} xs={12}></Grid>
            </Grid>
          )}
          <Typography variant="body2">
            <strong>Release Information</strong>
          </Typography>
          <Divider />
          <Grid className={classes.section} container>
            <Grid item md={6} xs={12}>
              <Grid container>
                <Grid item xs={8}>
                  <Typography variant="body2">
                    <strong>Requested Matched Info </strong>
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    {registration.receiveMatchInfo ? (
                      <CheckCircle style={{ fontSize: "small", color: "#008000" }} />
                    ) : (
                      <Block style={{ fontSize: "small", color: "#ff0000" }} />
                    )}
                  </Typography>
                </Grid>
                {registration.registrationType === RegistrationType.BIRTH_PARENT.value && (
                  <>
                    <Grid item xs={8}>
                      <Typography variant="body2">
                        <strong>Shared Medicial Information </strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body2">
                        {registration.shareMedicalHistory ? (
                          <CheckCircle style={{ fontSize: "small", color: "#008000" }} />
                        ) : (
                          <Block style={{ fontSize: "small", color: "#ff0000" }} />
                        )}
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography variant="body2">
                        <strong>Intermediary Contact </strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body2">
                        {registration.intermediaryContact ? (
                          <CheckCircle style={{ fontSize: "small", color: "#008000" }} />
                        ) : (
                          <Block style={{ fontSize: "small", color: "#ff0000" }} />
                        )}
                      </Typography>
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
            <Grid item md={6} xs={12}>
              <Grid container>
                {registration.registrationType === RegistrationType.BIRTH_PARENT.value && (
                  <>
                    <Grid item xs={8}>
                      <Typography variant="body2">
                        <strong>Release Birth Certificate </strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body2">
                        {registration.releaseBirthCertificate ? (
                          <CheckCircle style={{ fontSize: "small", color: "#008000" }} />
                        ) : (
                          <Block style={{ fontSize: "small", color: "#ff0000" }} />
                        )}
                      </Typography>
                    </Grid>
                  </>
                )}
                {registration.registrationType === RegistrationType.ADOPTEE.value && (
                  <>
                    <Grid item xs={8}>
                      <Typography variant="body2">
                        <strong>Receive Birth Certificate </strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body2">
                        {registration.receiveBirthCertificate ? (
                          <CheckCircle style={{ fontSize: "small", color: "#008000" }} />
                        ) : (
                          <Block style={{ fontSize: "small", color: "#ff0000" }} />
                        )}
                      </Typography>
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Typography variant="body2">
            <strong>Adoptee </strong>
          </Typography>
          <Divider />
          <Grid className={classes.section} container>
            <Grid item md={6} xs={12}>
              <Grid container>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Current Name </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {displayName(
                    registration.adopteeCurrentFirstName,
                    registration.adopteeCurrentMiddleName,
                    registration.adopteeCurrentLastName
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Birth Name </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {displayName(
                    registration.adopteeBirthFirstName,
                    registration.adopteeBirthMiddleName,
                    registration.adopteeBirthLastName
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Adoptive Name </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {displayName(
                    registration.adopteeAdoptiveFirstName,
                    registration.adopteeAdoptiveMiddleName,
                    registration.adopteeAdoptiveLastName
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Birth Date </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {birthDateRangeCheck(registration)}
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={6} xs={12}>
              <Grid container>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Birth City </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">{registration.birthCity}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Birth Hospital </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">{registration.birthHospital}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Other Birth Location </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">{registration.otherBirthLocation}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Gender </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">
                    {registration.birthSex
                      ? BirthSexOptions.find((sex) => sex.value === registration.birthSex).label
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Adoption Agency Attorney </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">{registration.adoptionAgencyAttorney}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Typography variant="body2">
            <strong>Adoptive Parents </strong>
          </Typography>
          <Divider />
          <Grid className={classes.section} container>
            <Grid item md={6} xs={12}>
              <Grid container>
                <Grid item xs={5}>
                  <Typography variant="body2">
                    <strong>First Adoptee Parent's Name </strong>
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography variant="body2">
                    {displayName(
                      registration.adoptiveParent1FirstName,
                      registration.adoptiveParent1MiddleName,
                      registration.adoptiveParent1LastName
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={6} xs={12}>
              <Grid container>
                <Grid item xs={5}>
                  <Typography variant="body2">
                    <strong>Second Adoptee Parent's Name </strong>
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography variant="body2">
                    {displayName(
                      registration.adoptiveParent2FirstName,
                      registration.adoptiveParent2MiddleName,
                      registration.adoptiveParent2LastName
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Typography variant="body2">
            <strong>Birth Parents </strong>
          </Typography>
          <Divider />
          <Grid className={classes.section} container>
            <Grid item md={6} xs={12}>
              <Grid container>
                <Grid item xs={5}>
                  <Typography variant="body2">
                    <strong>First Birth Parent's Name </strong>
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography variant="body2">
                    {displayName(
                      registration.birthParent1CurrentFirstName,
                      registration.birthParent1CurrentMiddleName,
                      registration.birthParent1CurrentLastName
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <Typography variant="body2">
                    <strong>Second Birth Parent's Name </strong>
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography variant="body2">
                    {displayName(
                      registration.birthParent2CertFirstName,
                      registration.birthParent2CertMiddleName,
                      registration.birthParent2CertLastName
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={6} xs={12}>
              <Grid container>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Birth Mother Alias </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">
                    {displayName(
                      registration.birthMotherAliasFirstName,
                      registration.birthMotherAliasMiddleName,
                      registration.birthMotherAliasLastName
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Typography variant="body2">
            <strong>Search Details</strong>
          </Typography>
          <Divider />
          <Grid className={classes.section} container>
            <Grid item md={6} xs={12}>
              <Grid container>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Last Searched By </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">
                    {displayName(
                      registration.lastSearchedBy?.contactInformation.firstName,
                      registration.lastSearchedBy?.contactInformation.middleName,
                      registration.lastSearchedBy?.contactInformation.lastName
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={6} xs={12}>
              <Grid container>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Last Searched Date </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">{displayDateMMDDYYYY(registration.lastSearchedDate)}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Typography variant="body2">
            <strong>Status </strong>
          </Typography>
          <Divider />
          <Grid className={classes.section} container>
            <Grid item md={6} xs={12}>
              <Grid container>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Fee Status </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">{FeeStatus[registration.feeStatus].label}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Registration Status </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">{RegistrationStatus[registration.registrationStatus].label}</Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={6} xs={12}>
              <Grid container>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <strong>Identification Status </strong>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">
                    {IdentificationStatus[registration.identificationStatus].label}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
